import FormBuilder from "../../Form"

export default function Preferences() {
  // Puedes personalizar estos valores

  return (
    <div>
      <FormBuilder />
    </div>
  )
}
